// Settings an administrator keeps for the whole register
const initialState = { code_prefix: null, number_scope: "bank", loaded: false };

// eslint-disable-next-line import/no-anonymous-default-export
export default (settings = initialState, action) => {
  switch (action.type) {
    case "SET_ASSET_SETTINGS":
      return { ...action.payload, loaded: true };
    default:
      return settings;
  }
};
